import styled from 'styled-components';
export const Item = styled.div`
  & + & {
    padding-left: 8px;
    position: relative;

    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 50%;
      zoom: 1.005; /* костыль для решения проблемы размытия контента внутри контейнера при использовании transform в браузере Google Chrome https://coderoad.ru/20326220/Размытый-текст-на-transform-rotate-в-Chrome#53556981 */
      transform: translateY(-50%);
      height: 24px;
      border-left: 1px solid #e5e7f1;
    }
  }
`;
export const List = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;